// react-query
import { milliseconds } from 'date-fns';
import { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
// redux
import { Provider as StoreProvider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { ModalProvider } from '@/components/Modal';
import { Spinner } from '@/components/Spinner';
import Toast from '../components/Toast/Toast';
import CustomRouter from '../navigation/customRouter';
import history from '../navigation/history';
import Routes from '../navigation/routes';
import store from '../store/store';
import AppErrorBoundary from './AppErrorBoundary';
import AppErrorGlobalFallback from './AppErrorGlobalFallback';
import '@/assets/styles/global.css';
import '@/assets/styles/tailwind.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: milliseconds({ seconds: 5 }),
      suspense: true,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const persistor = persistStore(store);

const App = () => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <StoreProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <CustomRouter history={history}>
              {/* 글로벌 Error Catch */}
              <AppErrorBoundary
                fallbackRender={({ error, errorInfo }) => (
                  <AppErrorGlobalFallback error={error} errorInfo={errorInfo} />
                )}
              >
                <ModalProvider>
                  {/* 페이지 레벨 Pending Catch */}
                  <Suspense fallback={<Spinner />}>
                    <Routes />
                  </Suspense>
                  <Toast />
                </ModalProvider>
              </AppErrorBoundary>
            </CustomRouter>
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
          </PersistGate>
        </StoreProvider>
      </QueryClientProvider>
    </>
  );
};

export default App;
